import styled from 'styled-components';
import Text from 'components/Text';
import PropTypes from 'prop-types';
import theme from 'utils/styles/theme';

import { space, margin, padding } from 'styled-system';

const Ul = styled(Text).attrs({
	as: 'ul'
})`
	list-style: none;
	padding: 0;
	margin: 0;
	text-align: ${props => props.textAlign};
`;

Ul.defaultProps = {
	mt: theme.space[3],
	mb: theme.space[3]
};

export default Ul;
